<template>
    <div >
        <b-modal v-if="true" @hide="onHide" centered id="pendings-modal" ref="pendingsModal" size="lg" hide-header hide-footer>
            <div class="modal-content">
                <button class="close-icon" @click="hideModal">
                    <Icon icon="close-modal"/>
                </button>
                <div v-if="!pendingRequests.loading" class="modal-content-body">
                    <p>
                        You have <span class="pending-count" v-if="pendingRequests.length < 10">{{pendingRequests.length}}</span> <span v-else class="pending-count">10+</span> pending <br>
                        Crossprom <span v-if="pendingRequests.length === 1">Request</span> <span v-else>Requests</span>
                    </p>
                    <div class="camps" :class="{'justify-content-around': pendingRequests.length < 3}">
                        <img 
                            v-for="item in pendingRequests.data" 
                            :key="item.id"
                            :src="item.sender.image" alt="">
                    </div>
                    <Button @click.native="toDashboard" type="pendings-modal">
                        View all in dashboard
                    </Button>
                </div>
                <Loader v-else/>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { computed, onMounted, watch } from '@vue/composition-api'
import { useRouter, useStore } from '../../core/hooks'
import Icon from '@/components/Theme/Icon'
import Button from '@/components/Theme/Button'
import usePendingsModal from './usePendingsModal'
import Loader from '../../components/Icons/Loader'
export default {
    name: 'PendingsModal',
    components: {
        Icon,
        Button,
        Loader
    },
    setup: function(props,context) {
        const {store} = useStore()
        const {router, route} = useRouter()
        const { pendingRequests, updateUserModel } = usePendingsModal()

        const hideModal = () => {
            context.root.$emit('bv::hide::modal', 'pendings-modal')
        }
        const onHide = (evt) => {
            updateUserModel()
            setTimeout(() => {
                store.commit('TOGGLE_MODAL', ['pendings-modal', false])
            }, 0)
            context.root.$ga.event('Pending Requests Modal', 'Modal Closed')
            context.root.$sendMixpanelEvent('Pending Requests Modal Closed')
        }
        const checkModalVisible = (arg) => {
            if(arg > 0) {
                context.root.$emit('bv::show::modal', 'pendings-modal')
                context.root.$ga.event('Pending Requests Modal', 'Modal Opened')
                context.root.$sendMixpanelEvent('Pending Requests Modal Opened')
            }
        }
        watch(pendingRequests, (pendings) => {
            checkModalVisible(pendings.length)
        }, {immediate: true})
        onMounted(() => {
            checkModalVisible(pendingRequests.length)
        })
        const toDashboard = () => {
            updateUserModel()
            context.root.$ga.event('Pending Requests Modal', 'View In Dashboard Clicked')
            context.root.$sendMixpanelEvent('Pending Requests Modal View In Dashboard Clicked')
            router.push('/dashboard/requests').catch(() => {})
        }
        return {
            onHide,
            toDashboard,
            hideModal,
            pendingRequests,
            updateUserModel,
        }
    }
}
</script>

<style lang="scss" scoped>
.modal-content {
    background: #ffffff !important;
    width: 760px;
    padding-top: 98px;
    padding-bottom: 56px;
    margin: 0 auto;
    position: relative;

    button.close-icon {
        position: absolute;
        top: 8px;
        right: 8px;
        padding: 0;
    }
    div.modal-content-body {
        max-width: 370px;
        margin: 0 auto;
        
        p {
            margin-bottom: 0;
            color: #333333;
            font-weight: bold;
            font-size: 32px;
            line-height: 48px;
            text-align: center;
            span.pending-count {
                color: #EAAE06;
            }
        }
        div.camps {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-top: 48px;
            padding-bottom: 56px;
            img {
                width: 96px;
                height: 96px;
                border-radius: 24px;
                object-fit: cover;
            }
        }
    }
}
</style>